import apiService from './api';

export interface UserResponse {
  id: string;
  email: string;
  name: string;
  role: string;
  is_active: boolean;
  organization_id: string;
  created_at: string;
  updated_at: string;
}

export interface CreateUserData {
  email: string;
  name: string;
  password: string;
  role?: string;
}

export interface UpdateUserData {
  name?: string;
  email?: string;
  role?: string;
  is_active?: boolean;
}

class UserService {
  async updateMe(data: Record<string, any>): Promise<any> {
    return apiService.patch('/users/me', data);
  }

  async getUsers(): Promise<UserResponse[]> {
    return apiService.get<UserResponse[]>('/users');
  }

  async getUser(id: string): Promise<UserResponse> {
    return apiService.get<UserResponse>(`/users/${id}`);
  }

  async createUser(data: CreateUserData): Promise<UserResponse> {
    return apiService.post<UserResponse>('/users', data);
  }

  async updateUser(id: string, data: UpdateUserData): Promise<UserResponse> {
    return apiService.patch<UserResponse>(`/users/${id}`, data);
  }

  async deleteUser(id: string): Promise<void> {
    return apiService.delete<void>(`/users/${id}`);
  }
}

export const userService = new UserService();
export default userService;
